import DateFnsUtils from "@date-io/date-fns";
import {
  Fab,
  Grid,
  Icon,
  MenuItem,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import Autocomplete from "components/Autocomplete";
import { LIST_CHAT_CHANNEL } from "constant";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import { useSelector } from "react-redux";

const REPORT_TYPES = [
  { id: 1, name: "Báo cáo lưu lượng theo từng ngày" },
  {
    id: 2,
    name: "Báo cáo lưu lượng theo khung giờ",
  },
  {
    id: 3,
    name: "Báo cáo lưu lượng theo từng tháng",
  },
];

const LIST_DEPARTMENT = [
  {
    id: "CSKH",
    name: "CSKH",
  },
  {
    id: "Bưu cục",
    name: "Bưu cục",
  },
  {
    id: "Bưu tá",
    name: "Bưu tá",
  },
];

const SearchBar = ({
  searchForm,
  onClickExport,
  listChartCriteria,
  chartCriteria,
  onChangeChartCriteria,
  disabled,
}) => {
  const contacts = useSelector((state) => state.dashboard.contact);
  const maxDate = new Date();
  maxDate.setHours(23, 59, 59, 999);

  const minEndDate = new Date(searchForm.values.startDate);
  minEndDate.setHours(0, 0, 0, 0);

  return (
    <form onSubmit={searchForm.handleSubmit}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={24}>
          <Grid item xs={12} md={3}>
            <TextField
              {...searchForm.getFieldProps("reportType")}
              select
              label="Loại báo cáo"
              variant="outlined"
              fullWidth>
              {REPORT_TYPES.map((item) => (
                <MenuItem value={item.id}>{item.name}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <InlineDatePicker
              label="Từ ngày"
              variant="outlined"
              format="dd-MM-yyyy"
              value={searchForm.values.startDate}
              onChange={(date) => {
                searchForm.setFieldValue("startDate", date);
              }}
              maxDate={maxDate}
              fullWidth
              invalidDateMessage="Định dạng Ngày không đúng"
              error={Boolean(searchForm.errors?.startDate)}
              helperText={searchForm.errors?.startDate}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <InlineDatePicker
              label="Đến ngày"
              variant="outlined"
              value={searchForm.values.endDate}
              onChange={(date) => searchForm.setFieldValue("endDate", date)}
              maxDate={maxDate}
              minDate={minEndDate}
              format="dd-MM-yyyy"
              fullWidth
              invalidDateMessage="Định dạng Ngày không đúng"
              error={Boolean(searchForm.errors?.endDate)}
              helperText={searchForm.errors?.endDate}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              {...searchForm.getFieldProps("department")}
              select
              label="Bộ phận"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}>
              {LIST_DEPARTMENT.map((item) => (
                <MenuItem value={item.id}>{item.name}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Autocomplete
              options={contacts}
              getLabel={(item) => item?.name || ""}
              onChangeValue={(newValue) => {
                searchForm.setFieldValue("contactCenter", newValue);
              }}
              value={searchForm.values.contactCenter}
              label="Contact center"
              InputLabelProps={{
                shrink: true,
              }}
              isVisibleAllOption
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              {...searchForm.getFieldProps("chatChannel")}
              select
              label="Kênh chat"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              value="develop">
              {[{ id: "develop", name: "Đang phát triển" }]
                .concat(LIST_CHAT_CHANNEL)
                .map((item) => (
                  <MenuItem value={item.id}>{item.name}</MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              // {...searchForm.getFieldProps("pageSource")}
              select
              label="Nguồn trang"
              variant="outlined"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              value="develop">
              {[{ id: "develop", name: "Đang phát triển" }].map((item) => (
                <MenuItem value={item.id}>{item.name}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              value={chartCriteria}
              onChange={(e) => onChangeChartCriteria(e.target.value)}
              select
              label="Tiêu chí biểu đồ"
              variant="outlined"
              fullWidth>
              {listChartCriteria.map((item) => (
                <MenuItem value={item.id}>{item.title}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Tìm kiếm" disableFocusListener>
              <Fab
                color="primary"
                style={{ marginLeft: "15px" }}
                type="submit"
                disabled={disabled}>
                <Search />
              </Fab>
            </Tooltip>
            <Tooltip title="Tải báo cáo" disableFocusListener>
              <Fab
                color="primary"
                style={{ marginLeft: "15px" }}
                onClick={onClickExport}
                disabled={disabled}>
                <Icon>save_alt</Icon>
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </form>
  );
};

export default SearchBar;
